import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for M209 (研發架號修改單)
// ============================================================

export interface FM220 {
  fm220_01: string;          // 修改單號 (PK)
  fm220_11: string | null;   // 修改日期 (ISO string)
  fm220_12: string;          // 建單人員
  fm220_13: string;          // 部門代碼
  fm220_14: string;          // 庫位代號
  fm220_15: number;          // 總項數
  fm220_80: string;          // 核准狀態
  fm220_91: string;          // 建立人員
  fm220_92: string | null;   // 存檔時間
  fm220_93: string;          // 修改人員

  // Associations
  details?: FM221[];
}

export interface FM221 {
  fm221_01: string;          // FK→FM220_01
  fm221_02: number;          // 項次
  fm221_11: string;          // 批號
  fm221_12: string;          // 產品代號
  fm221_14: string;          // 色號 (auto from FM030_51)
  fm221_21: string;          // 原架號 (auto from FM030_57)
  fm221_22: string;          // 新架號 (user input)
}

// ============================================================
// Request / Response types
// ============================================================

export interface M209ListResponse {
  data: FM220[];
  total: number;
  page: number;
  size: number;
}

export interface M209CreateRequest {
  fm220_11: string | null;   // 修改日期
  fm220_12: string;          // 建單人員
  fm220_13: string;          // 部門代碼
  fm220_14: string;          // 庫位代號
  details: Partial<FM221>[];
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const m209Api = {
  async list(page = 1, size = 20): Promise<M209ListResponse> {
    const res = await apiClient.get('/api/m209', { params: { page, size } });
    return res.data;
  },

  async get(id: string): Promise<FM220> {
    const res = await apiClient.get(`/api/m209/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: M209CreateRequest): Promise<FM220> {
    const res = await apiClient.post('/api/m209', data);
    return res.data;
  },

  async update(id: string, data: M209CreateRequest): Promise<FM220> {
    const res = await apiClient.put(`/api/m209/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/m209/${encodeURIComponent(id)}`);
  },

  async approve(id: string): Promise<FM220> {
    const res = await apiClient.post(`/api/m209/${encodeURIComponent(id)}/approve`);
    return res.data;
  },

  async search(keyword: string, page = 1, size = 20): Promise<M209ListResponse> {
    const res = await apiClient.get('/api/m209', { params: { keyword, page, size } });
    return res.data;
  },
};
